// @ts-nocheck
import { robotoRegular, scarpaGray500 } from '@habitech/shared';
import styled from 'styled-components';

/** Vista de dos columnas (título | formulario) desde este ancho */
const desktopGrid = `(min-width: 1024px)`;

export const Container = styled.div`
    padding: 28px 24px 64px;
    max-width: 680px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 0;
    box-sizing: border-box;
    font-family: ${robotoRegular};
    font-size: 16px;
    line-height: 1.5;

    form {
        margin: 0;
        max-width: 560px;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 0;
    }

    @media ${({ theme }) => theme.screenSizes.tablet} {
        padding: 28px 32px 64px;
    }

    @media ${desktopGrid} {
        display: grid;
        grid-template-columns: 347px auto;
        column-gap: 40px;
        row-gap: 0;
        align-items: start;
        max-width: 1120px;
        padding: 36px 40px 72px;

        form {
            max-width: none;
            margin: 0;
        }
    }

    @media ${({ theme }) => theme.screenSizes.laptop} {
        column-gap: 48px;
        padding: 40px 24px 80px;
        max-width: 1180px;
    }
`;

/** Columna derecha del layout desktop: evita desborde en grid y aloja el formulario */
export const FormColumn = styled.div`
    width: 100%;
    min-width: 0;
    display: flex;
    flex-direction: column;
`;

export const PageHeader = styled.div`
    margin: 0 0 24px;
    max-width: 560px;
    width: 100%;
    box-sizing: border-box;

    @media ${({ theme }) => theme.screenSizes.tablet} {
        margin: 0 0 28px;
    }

    @media ${desktopGrid} {
        margin: 0;
        max-width: none;
        padding: 4px 8px 0 0;
    }
`;

export const IntroText = styled.p`
    font-family: ${robotoRegular};
    font-size: 16px;
    line-height: 1.55;
    color: ${scarpaGray500};
    margin: 10px 0 0;

    @media ${desktopGrid} {
        max-width: none;
    }
`;
